//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  UserMixin,
} from "~/node_modules/sitis-nuxt/lib/mixins";
import {required, minLength, email} from "vuelidate/lib/validators";

export default {
  name:'CommentsForm',
  data() {
    return {
      reviews: [],
      responseMessage: "",
      formReviews: {
        name: "",
        text: "",
        attachments: [],
      },
      isSubmitReviews: false,
      isShowForm: false,
      isPrivacyPolicy: true,
      isConsentProcessing: true,
    };
  },

  mixins: [
    UserMixin
  ],

  computed: {

    isShowFormName: function () {
      return !Boolean(this?.user?.name)
    },

    isShowFormEmail: function () {
      return !Boolean(this?.user?.phone)
    },

  },

  watch: {
    formReviews() {
      this.$v.$reset();
    },
  },

  validations: function () {

    let formReviews = {
      text: {
        required,
        minLength: minLength(10),
      }
    };

    if (this.isShowFormName) {
      formReviews.name = {
        required,
        minLength: minLength(4),
      };
    }
    if (this.isShowFormEmail) {
      formReviews.email = {
        required,
        email,
      };
    }

    return {
      formReviews
    }
  },

  async mounted() {
    try {
      const {data: reviews} = await this.$api.agent.transport.get(
        `reviews?filter[model]=${this.model}&filter[model_key]=${this.modelKey}`
      );
      this.reviews = reviews;
    } catch (error) {
      console.log(error);
    }
  },

  methods: {
    formatDate(timeStamp) {
      return new Date(timeStamp *1000).toLocaleDateString("ru", {
        day: '2-digit',
        month: "long",
        year: 'numeric'
      });
    },

    onChangeReviews({target}) {
      let newFormReviews = {...this.formReviews};
      const {name, value} = target;
      newFormReviews[name] = value;
      this.formReviews = Object.assign({}, this.formReviews, newFormReviews);
    },
    onChangeFilesReviews({target}) {
      let newFormReviews = {...this.formReviews};
      const {name, value, files} = target;
      newFormReviews[name] = [...newFormReviews[name], ...files];
      this.formReviews = Object.assign({}, this.formReviews, newFormReviews);
    },
    onCloseFilesRewiews(idx) {
      this.formReviews.attachments.splice(idx, 1);
    },
    async onSendReviews() {
      this.isSubmit = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }
      try {
        this.isSubmitReviews = true;
        let formData = new FormData();
        formData.append("entities[0][model]", this.model);
        formData.append("entities[0][model_key]", this.modelKey);
        formData.append("name", (this.formReviews.name || this?.user?.name));
        formData.append("text", this.formReviews.text);

        if (this.formReviews.email || this?.user?.email) {
          formData.append("email", (this.formReviews.email || this?.user?.email || ""));
        } else {
          formData.append("phone", this?.user?.phone);
        }

        Object.keys(this.formReviews.attachments).map((key) => {
          formData.append("attachments[]", this.formReviews.attachments[key]);
        });
        const response = await this.$api.agent.transport.post(
          "reviews",
          formData
        );
        if (response) {
          this.$nextTick(() => {
            this.formReviews = {name: "", text: "", attachments: []};
            this.$v.$reset();
          });
          this.responseMessage =
            "Спасибо. Ваш комментарий принят и ожидает проверки!";
        }
        this.isSubmitReviews = false;
      } catch (err) {
        console.log(err.response);
      }
    },
  },
  props: {
    modelKey: [String, Number],
    model: String,
  },
};
